import { Component } from '@angular/core';
import { AppState } from '../../config/state';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { LoginProvider } from '../../providers/login/login';
import { NavParams } from 'ionic-angular';
// import { Brightness } from '@ionic-native/brightness/ngx';

/**
 * Generated class for the CoLibraryCardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-co-library-card',
  templateUrl: 'co-library-card.html',
})
export class CoLibraryCardPage {
  cardNumber: string;
  cardImage: string;
  clientKeyword: string;
  menuSide: string = "left";
  logo: string = "";
  oldBrightness: any;
  constructor(private state: AppState, private client: ClientDetailsProvider, private loginProvider: LoginProvider, private navParams: NavParams) {
    this.state.burgerMenu && this.state.burgerMenu.menuSide ? this.menuSide = this.state.burgerMenu.menuSide : this.menuSide = "hidden";
    this.client.load().then((res) => {
      this.clientKeyword = res.keyword;
    });

    if (this.navParams.data.barcode && this.navParams.data.barcode !== '') {
      this.cardNumber = this.navParams.data.barcode;
    } else {
      this.loginProvider.requireLogin((res) => {
        this.cardNumber = res.barcode;
      });
    }
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.brightness.getBrightness().then(old => this.oldBrightness = old)
      // .catch(err => console.log('cannot get brightness... ' + err));
  }

  ionViewDidEnter(){
    // this.brightness.setBrightness(1).catch(err => console.log('cannot set brightness... ' + err));
  }

  ionViewDidLeave(){
    // this.brightness.setBrightness(this.oldBrightness).catch(err => console.log('cannot set brightness... ' + err));
  }
}



// WEBPACK FOOTER //
// ./src/pages/co-library-card/co-library-card.ts